export default "__VITE_ASSET__dc5e3798__"